
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/insurance",
      function () {
        return require("private-next-pages/solutions/insurance.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/insurance"])
      });
    }
  